import { DetailsEditor } from "uikit"
import FaqLinks from "components/FaqLinks"
import React, { useEffect, useState } from "react"
import { useStore } from "store"
import { accountTypes } from "../accountTypes"
import EditableAccountName from "../EditableAccountName"
import { Input } from "semantic-ui-react"

const AccountDetailsView = props => {
  const {
    household,
    success,
    type,
    isNew,
    onSubmit,
    onDelete,
    accountId,
    confirm,
    changeTypeLink
  } = props

  const { view: Worksheet } = accountTypes[type]
  const [{ label, description, faqs = [] }] = useStore(
    "contextuals",
    `Account: ${type}`
  )

  const [newAccountName, setNewAccountName] = useState(label)
  const onInputChange = ({ target: { value } }) => {
    setNewAccountName(value)
  }

  useEffect(() => {
    window.trackEvent("edit-account", { type })
  }, [type])

  function editor(accountEditor, heading) {
    return (
      <DetailsEditor
        heading={confirm ? `Confirm ${label} Account` : heading}
        description={description}
        supplement={faqs.length ? <FaqLinks items={faqs} /> : null}
      >
        <Worksheet
          household={household}
          account={accountEditor}
          success={success}
          submit={async values => {
            await onSubmit({
              ...values,
              ...(isNew && { name: newAccountName })
            })
            return
          }}
          onDelete={onDelete}
          isNew={isNew}
          forceModified={!!confirm}
          type={type}
        />
      </DetailsEditor>
    )
  }

  if (isNew) {
    return editor(
      null,
      <span>
        Add{" "}
        <Input
          size="mini"
          placeholder="Account Nickname"
          value={newAccountName}
          onChange={onInputChange}
        />{" "}
        Account
      </span>
    )
  }

  return (
    <AccountDetailsEditor
      accountId={accountId}
      confirm={confirm}
      changeTypeLink={changeTypeLink}
      editor={editor}
    />
  )
}

const AccountDetailsEditor = props => {
  const [account, { updateAccount }] = useStore("accounts", props.accountId)
  const heading = (
    <EditableAccountName
      name={account.name}
      submit={accountName =>
        updateAccount({
          id: account.id,
          type: account.type,
          name: accountName
        })
      }
      confirm={props.confirm}
      changeTypeLink={props.changeTypeLink}
    />
  )

  return props.editor(account, heading)
}

export default AccountDetailsView
